import React from 'react';

const FormInfo = props => {
  if (!props.purchase || !props.listname) {
    return null;
  }

  // direct present
  if (props.purchase === 'direct') {
    return (
      <React.Fragment>
        <p>
          Bitte füllen Sie das untenstehende Formular aus. Die Kontaktdaten
          dienen nur unserer internen Dokumentation und werden vertraulich
          behandelt.
        </p>
        <p>
          Sie erhalten alle notwendigen Informationen per E-Mail, damit{' '}
          <strong>
            Sie das Geschenk selbst in der Lutherkirche abgeben können.
          </strong>
        </p>
      </React.Fragment>
    );
  }

  // donation present
  return (
    <React.Fragment>
      <p>
        Bitte füllen Sie das untenstehende Formular aus. Die Kontaktdaten dienen
        nur unserer internen Dokumentation und werden vertraulich behandelt.
        Bitte{' '}
        <strong>geben Sie den Betrag ein, den Sie spenden möchten.</strong>
      </p>
    </React.Fragment>
  );
};
export default FormInfo;



// WEBPACK FOOTER //
// ./src/Component/FormInfo.js